/**
 * In-memory page size for instructor gradebook V2.
 * Used by getGradebookInstructor when callers omit pageSize/limit so filters,
 * search, and other refetches preserve the user's rows-per-page selection
 * while the gradebook is mounted. Cleared when the provider unmounts (e.g.
 * navigating away), matching hard-refresh behavior on return.
 */
let sessionPageSize = null;

export function getInstructorGradebookSessionPageSize(defaultLimit = 25) {
  return sessionPageSize ?? defaultLimit;
}

export function setInstructorGradebookSessionPageSize(pageSize) {
  sessionPageSize = pageSize;
}

export function resetInstructorGradebookSessionPageSize() {
  sessionPageSize = null;
}
